import TopBar from '../components/TopBar';
import { useState, React } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { tokens } from "../theme";
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';
import RegexValidatedTextField from '../components/RegexValidatedTextField';

import CreateAccountIcon from '@mui/icons-material/PersonAdd';

function CreateAccount() {
    // Contains values in the text fields
    const [fieldValues, setFieldValues] = useState({
        username: '',
        displayName: '',
        password: ''
    })

    const navigate = useNavigate();

    const [error, setError] = useState('');

    // Contains bool determining if the input fields are valid
    const [validity, setValidity] = useState({
      username: false,
      password: false,
    });

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const usernameRegex = new RegExp("^\\S{1,255}$");
    const passwordRegex = new RegExp("^\\S{1,255}$");

    /**
     * Creates a new account based on the fieldValues
     * and sends it to the server.
     * @param {{ username: string, displayName: string, password: string}} fieldValues
     * The values to create the account with.
     */
    async function handleCreateAccount() {
        setError('')
        if (fieldValues.password === "") {
          setError('Du måste ange ett lösenord');
        } else {
            try {
              const res = await api.post('/create_account', fieldValues);
              if (res.data.success) {
                  navigate('/login') // Redirect to login page after successful account creation
              }
            } catch (err) {
              if (err.response && err.response.status === 409) {
                  setError('Användarnamnet är redan upptaget');
              } else {
                  setError('Något oväntat gick fel');
              }
            }
        }
    }

    return (
    <div>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
        <Typography
          variant="h4"
          color={colors.ceriseAccent[100]}
          fontWeight="medium"
          sx={{m: "0 0 10px 0"}}
          >
          Skapa ett konto
        </Typography>
        <RegexValidatedTextField
          label="Användarnamn"
          variant="outlined"
          value={fieldValues.username}
          regex={usernameRegex}
          errorMessage="Felaktigt användarnamn"
          onValidChange={(value, isValid) => {
            setFieldValues(prev => ({ ...prev, username: value }));
            setValidity(prev => ({ ...prev, username: isValid }));
          }}
          sx={{m: "10px 0 0 0"}}
          >
        </RegexValidatedTextField>
        <TextField
          label="Visningsnamn"
          variant="outlined"
          value={fieldValues.displayName}
          onChange={(e) => setFieldValues({...fieldValues, displayName: e.target.value})}
          sx={{m: "10px 0 0 0"}}
          >
        </TextField>
        <RegexValidatedTextField
          label="Lösenord"
          variant="outlined"
          type="password"
          regex={passwordRegex}
          errorMessage="Felaktigt lösenord"
          value={fieldValues.password}
          sx={{m: "10px 0 0 0"}}
          onValidChange={(value, isValid) => {
            setFieldValues(prev => ({ ...prev, password: value }));
            setValidity(prev => ({ ...prev, password: isValid }));
          }}
          >
        </RegexValidatedTextField>
        {
            error ?
            <Typography
            variant="h6"
            color={colors.redAccent[300]}
            fontWeight="medium" 
            sx={{m : "10px 0 0px 0px" }}
            >
            {error}
            </Typography>
            : null
        }
        <Button
          variant="outlined"
          color={colors.gray[900]}
          sx={{width: "150px", m: "10px 0 0 0px"}}
          onClick={handleCreateAccount}
          disabled={!(validity.username && validity.password)}
        >
            <CreateAccountIcon/>
            <Typography
            variant="h6"
            color={colors.gray[100]}
            fontWeight="medium" 
            sx={{m : "5px 0 5px 15px" }}
            >
            Skapa konto
            </Typography>
        </Button>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" sx={{m: "10px 0 0 0"}}>
          <Typography
              variant="h6"
              color={colors.gray[100]}
              fontWeight="medium"
              sx={{m: "0 5px 0 0"}}
              >
              Har du redan ett konto?
          </Typography>
          <Typography
              variant="h6"
              color={colors.ceriseAccent[100]}
              fontWeight="medium" 
              onClick={() => navigate('/login')}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
              Logga in här
          </Typography>
        </Box>
      </Box>
    </div>
    )
}

export default CreateAccount